"use client";
import { useEffect, useRef, useState } from "react";

export default function OnVisible({
                                      children,
                                      rootMargin = "100% 0px",
                                  }: { children: React.ReactNode; rootMargin?: string }) {
    const ref = useRef<HTMLDivElement>(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        if (!("IntersectionObserver" in window)) { setShow(true); return; }

        const io = new IntersectionObserver(([e]) => {
            if (e.isIntersecting) { setShow(true); io.disconnect(); }
        }, { rootMargin });

        io.observe(el);
        return () => io.disconnect();
    }, [rootMargin]);

    return (
        <div ref={ref} style={{ minHeight: 1, width: 1, position: "relative" }}>
            {show ? children : null}
        </div>
    );
}